import { Drawer, useTheme } from '@mui/material';

type BottomDrawerProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export const BottomDrawer = ({
  open,
  onClose,
  children,
}: BottomDrawerProps) => {
  const theme = useTheme();

  return (
    <Drawer anchor="bottom" open={open} onClose={onClose}>
      <div
        style={{
          backgroundColor: theme.palette.background.default,
        }}
      >
        {children}
      </div>
    </Drawer>
  );
};
